import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, Table, Dropdown } from '@themesberg/react-bootstrap';
import { store } from 'react-notifications-component';
import { apiCall, apiRoutes, firstLetterCaps, getToaster } from 'utils/helpers';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { SUCCESS, APP_NAME, DANGER } from 'utils/constants/notifyTypes';
import Loader from 'components/Loader';

export const TestimonialTables = ({
    dispatchStudent,
    editFunc,
    dataState,
}: {
    dataState: any;
    dispatchStudent: any;
    editFunc: any;
}) => {
    const data = dataState?.data || [];
    const [isLoading, setIsLoading] = useState(false);

    const deleteFunc = async (id: number) => {
        const url = { ...apiRoutes.deleteTestimonial };
        url.apiPath = url.apiPath.replace(':testimonialId', id ? id.toString() : '');
        const response = await apiCall(url);

        if (response?.data?.status) {
            setIsLoading(false);
            window.location.reload();
            store.addNotification(getToaster(`${APP_NAME} Testimonial`, response?.data?.message, SUCCESS));
        } else {
            setIsLoading(false);
            store.addNotification(getToaster(`${APP_NAME} Testimonial`, response?.data?.error[0], DANGER));
        }
    };

    const dispatchDelete = async (id: number) => {
        setIsLoading(true);
        await deleteFunc(id);
    };

    // eslint-disable-next-line no-shadow
    const TableRow = ({ data, index }: { data: any; index: number }) => {
        return (
            <tr>
                <td>
                    <span className="fw-normal">{index + 1}</span>
                </td>

                <td>
                    <span className="fw-normal">{firstLetterCaps(data?.name)}</span>
                </td>
                <td>
                    <span className="fw-normal">{data?.email}</span>
                </td>

                <td>
                    <span className="fw-normal">{data?.position}</span>
                </td>
                <td>
                    <span className="fw-normal">{data?.content}</span>
                </td>

                <td>
                    <Dropdown.Item onClick={() => editFunc(data)}>
                        <FontAwesomeIcon icon={faEdit} className="me-2" /> Edit
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => dispatchDelete(data?.id)}>
                        <FontAwesomeIcon icon={faTrash} className="me-2" /> Delete
                    </Dropdown.Item>
                </td>
            </tr>
        );
    };

    return (
        <Card border="light" className="table-wrapper table-responsive shadow-sm">
            {isLoading ? <Loader isLoad /> : null}
            <Card.Body className="pt-0">
                <Table hover className="user-table align-items-center">
                    <thead>
                        <tr>
                            <th className="border-bottom">#</th>
                            <th className="border-bottom">Name</th>
                            <th className="border-bottom">Email</th>
                            <th className="border-bottom">Position</th>
                            <th className="border-bottom">Content</th>
                            <th className="border-bottom">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((payloadData: any, index: number) => {
                            return <TableRow data={payloadData} index={index} key={`transaction-${payloadData.id}`} />;
                        })}
                    </tbody>
                </Table>
            </Card.Body>
        </Card>
    );
};
